import { render } from "./VesCalendarLegend.vue?vue&type=template&id=114e2a94&scoped=true"
import script from "./VesCalendarLegend.vue?vue&type=script&lang=js"
export * from "./VesCalendarLegend.vue?vue&type=script&lang=js"

import "./VesCalendarLegend.vue?vue&type=style&index=0&id=114e2a94&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114e2a94"]])

export default __exports__